import React from 'react';

import Advantage from 'pages/Landings/components/Advantage';
import Advantages from 'pages/Landings/components/Advantages';
import {
    ChatIcon,
    DataDepthIcon,
    DataScaleIcon,
    RocketIcon,
    WhiteLabelLargeColoredIcon
} from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const WhiteLabel: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Vulners White-Label Solutions"
                    description="Build Faster, Earn More, and Innovate Freely"
                    illustration={<WhiteLabelLargeColoredIcon />}
                />
            }
            content={
                <TopicContent>
                    <Paragraph
                        primary="Build Faster, Earn More, and Innovate Freely"
                        secondary="Vulners White-Label Solutions let you ship vulnerability intelligence inside your own product without building (and maintaining) a vulnerability database or detection logic. Plug into a comprehensive platform and accelerate time-to-market, trim engineering overhead, and spend your cycles on the features that differentiate you - instead of reinventing essentials."
                    />
                    <Paragraph
                        primary="Fast Time-to-Market & Low Development Overhead"
                        secondary="Launching a security feature usually means curating massive datasets, writing detection logic, and babysitting constant integration contracts updates. Vulners removes that tax with a continuously updated knowledge base and robust APIs/SDKs. Your team integrates once and skips months - sometimes years - of backend work. You deliver to customers in a fraction of the time, without standing up or operating complex infrastructure."
                    />
                    <Paragraph
                        primary="Advanced Vulnerability Intelligence Integration"
                        secondary="Get advanced vulnerability intelligence out of the box. Vulners aggregates hundreds of sources - CVEs, vendor advisories, exploit databases, security feeds - into a unified, real-time stream. It’s not just raw data: each item is enriched with correlated intelligence, exploit availability, predictive risk scoring, not to mention all standard industry metrics. Your product surfaces up-to-the-minute insights and smarter prioritization so users focus on what actually matters. Integration is straightforward and reliable via clean APIs and SDKs."
                    />
                    <Paragraph
                        primary="New Revenue Streams & Flexible Integration"
                        secondary="Grow revenue by expanding your security portfolio - without a heavy build. Vulners White-Label lets you add capabilities to existing platforms or stand up entirely new offerings, all powered under your brand. Embed assessment in an IT management tool, or launch a vulnerability scanning service - new revenue streams with minimal incremental investment. An OEM-friendly design and licensing model keep the experience native to your UI and your customers."
                    />
                </TopicContent>
            }
            advantages={
                <Advantages title="Why Vulners? Unmatched Data and Support">
                    <Advantage
                        icon={<DataDepthIcon />}
                        title="Data Depth"
                        description="Immediate access to a comprehensive, correlated vulnerability corpus - millions of records linked across exploits, patches, and advisories - kept continuously up to date so your product is never stale."
                    />
                    <Advantage
                        icon={<DataScaleIcon />}
                        title="OEM & Integration Flexibility"
                        description="Embed only what you need - from raw feeds to full assessment modules. The SDK is designed for startups and enterprises alike, scaling from focused features to large deployments without paying for extras you won’t use."
                    />
                    <Advantage
                        icon={<RocketIcon />}
                        title="Startup-Friendly Pricing"
                        description="Flexible partner/OEM models meet you where you are, lowering the barrier to experiment, iterate, and ship cost-effectively."
                    />
                    <Advantage
                        icon={<ChatIcon />}
                        title="Free Engineering Support"
                        description="Your developers get direct, no-cost access to Vulners engineers - guides, examples, and one-on-one help—so you can integrate quickly even if you’re not vulnerability specialists."
                    />
                </Advantages>
            }
        />
    );
};

export default WhiteLabel;
